import { Button, Modal } from "react-bootstrap";
import { PiSealWarningFill } from "react-icons/pi";


function ConfirmationModal({ show, onClose, onConfirm }) {
    return (
        <Modal show={show} onHide={onClose} centered>
            <Modal.Body className="d-flex flex-column align-items-center gap-3">
                <div className="d-flex align-items-center gap-2 text-warning" style={{ fontSize: 40 }}>
                    <PiSealWarningFill />
                </div>
                <div className="d-flex flex-column text-danger text-center">
                    <span>Are you sure you want to submit?</span>
                    <span>Once submitted, you won't be able to edit your answers.</span>
                </div>
                <div className="d-flex justify-content-center gap-2 w-100">
                    <Button variant="light" style={{ border: '1px solid #ced4da' }} onClick={onClose}>
                        Cancel
                    </Button>
                    <Button variant="warning" onClick={onConfirm}>
                        Submit
                    </Button>
                </div>
            </Modal.Body>
        </Modal>
    );
}

export default ConfirmationModal;